import React, { FC } from 'react'
import { Divider } from '@mui/material'
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined'

import { Typography } from '@dg-shared'
import { useTranslate } from '../../hooks/shared'
import { TRANSLATIONS as T } from '../../constants'
import BaseCard, { useCardStyles } from './BaseCard'

export interface InvoiceCardData {
  id: string
  dueDate: string
  title: string
  subtitle: string
  dateRange: string
  amount: string
  accountNumber?: string
  kid?: string
  paymentMethod?: string
}

interface InvoiceCardProps {
  data: InvoiceCardData
}

const InvoiceCard: FC<InvoiceCardProps> = ({ data }) => {
  const { classes } = useCardStyles()
  const { t } = useTranslate(T.INVOICES)
  const accountNumber = data.accountNumber
  const kid = data.kid

  const copyToClipboard = (value: string) => navigator.clipboard.writeText(value)

  return (
    <BaseCard
      headerItems={[
        { text: t('card.dueDate'), type: 'h2' },
        { text: data.dueDate, type: 'h2' },
      ]}
      testId={`invoice-item-${data.id}`}
    >
      <div className={classes.body}>
        <Typography className={classes.title}>{data.title}</Typography>
        {data.subtitle && <Typography className={classes.subtitle}>{data.subtitle}</Typography>}
        <Typography className={classes.subtitle}>{data.dateRange}</Typography>
        <Divider />
        <div className={classes.row}>
          <Typography>{t('card.amount')}</Typography>
          <Typography>{data.amount}</Typography>
        </div>
        {accountNumber && (
          <div className={classes.row}>
            <Typography>{t('card.account')}</Typography>
            <div className={classes.rowValueInline}>
              <FileCopyOutlinedIcon
                className={classes.copyIcon}
                onClick={() => copyToClipboard(accountNumber)}
              />
              <Typography>{accountNumber}</Typography>
            </div>
          </div>
        )}
        {kid && (
          <div className={classes.row}>
            <Typography>{t('card.kid')}</Typography>
            <div className={classes.rowValueInline}>
              <FileCopyOutlinedIcon
                className={classes.copyIcon}
                onClick={() => copyToClipboard(kid)}
              />
              <Typography>{kid}</Typography>
            </div>
          </div>
        )}
        {data.paymentMethod && (
          <div className={classes.row}>
            <Typography>{t('card.paymentMethod')}</Typography>
            <Typography className={classes.bold}>{data.paymentMethod}</Typography>
          </div>
        )}
      </div>
    </BaseCard>
  )
}

export default InvoiceCard
